import React from 'react';
import { TransferTimelineModal } from './TransferredItems/components/TransferTimelineModal';
import { allDispCodes } from '../../components/AssetRelocationForms/utils';
import { SalvageTimelineModal } from './SalvageItems/components/SalvageTimelineModal';
import { PCEmail } from './TransferredItems/components/PCEmail';
import { Button } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { DateFilter } from './SalvageItems/components/DateFilter';

// change this
function editSalvageItem({ value, row }: any) {
  if (value != null) {
    let link = `/salvage/approval/${row._original.salvageId}`;
    return (
      <div style={{ textAlign: 'center' }}>
        <a href={link} className='info'>
          Edit
        </a>
      </div>
    );
  } else {
    return '';
  }
}

function salvageCodeFull({ value, row }: any) {
  if (value !== null) {
    let codes = allDispCodes.filter((item, index) => {
      return item.code === row._original.salvageFormDispositionCode;
    })
    if(codes.length > 0) {
      return `${codes[0].code}: ${codes[0].name}`;
    }
      return ''
  }
  return '';
}

function salvageFilterField({ value, row }: any) {
  // return <Button variant='info'>Test</Button>
  return (
    <div style={{ height: 'auto', overflow: 'visible' }}>
      <DateFilter value={value} row={row} />
    </div>
    // <DatePicker
    //   // start
    //   // popperPlacement='top'

    //   // openToDate={new Date()}
    //   className='form-control col-sm'
    //   // inline
    //   selectsRange
    // withPortal
    //   isClearable
    //   selected={value ? new Date(value) : value}
    //   onChange={() => console.log('filter change: ')}
    // />
  );
}

function eoneCodeFull({ value, row }: any) {
  if (value !== null) {
    let codes = allDispCodes.filter((item, index) => {
      return item.code === row._original.enterpriseOneDispositionCode;
    })
    if(codes.length > 0){
      return `${codes[0].code}: ${codes[0].name}`;
    }
    return ''
  }
  return '';
}

export const salvageColumns = [
  {
    column: {
      Header: '',
      accessor: 'salvageId',
      type: 'string',
      width: 50,
      resizable: true,
      Cell: editSalvageItem,
      filterable: false,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Asset #',
      accessor: 'assetNumber',
      resizable: true,
      type: 'string',
      width: 70,
    },
    type: 'string',
  },

  {
    column: {
      Header: 'Barcode',
      accessor: 'barCode',
      resizable: true,
      type: 'string',
      width: 90,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Serial Number',
      resizable: true,
      accessor: 'serialNumber',
      type: 'string',
      width: 100,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Description 1',
      accessor: 'description1',
      resizable: true,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Description 2',
      resizable: true,
      accessor: 'description2',
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Description 3',
      accessor: 'description3',
      resizable: true,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Salvage Form Code',
      accessor: 'salvageFormDispositionCode',
      type: 'string',
      resizable: true,
      width: 175,
      Cell: salvageCodeFull,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'EOne Code',
      accessor: 'enterpriseOneDispositionCode',
      type: 'string',
      resizable: true,
      width: 100,
      Cell: eoneCodeFull,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'PC&A Approval Date',
      accessor: 'pcaApprovalDate',
      resizable: true,
      type: 'date',
      // expander: true,
      // filterable: false,
      // Filter: salvageFilterField,
    },
    type: 'date',
  },
  {
    column: {
      Header: 'Salvage Status',
      resizable: true,
      accessor: 'updateStatus',
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Timeline',
      type: 'string',
      resizable: true,
      width: 60,
      Cell: salvageTimeline,
    },
    type: 'string',
  },
];

function editEOneItem({ value, row }: any) {
  if (value != null) {
    let link = `/transfers/approval/${row._original.updateId}`;
    return (
      <div style={{ textAlign: 'center' }}>
        <a href={link} className='info'>
          Edit
        </a>
      </div>
    );
  } else {
    return '';
  }
}

function transferTimeline({ value, row }: any) {
  if (value !== '') {
    return <TransferTimelineModal barcode={row.barCode} />;
  }
  return '';
}

function sendPCEMail({ value, row }: any) {
  if (value !== null && row.updateStatus === 'Transfer Installed, Pending Approval') {
    // return row._original.toDeptId
    
    return <PCEmail toDept={row.toDeptName} process='transfer' row={row._original} />;
  }
  return '';
}

function salvageTimeline({ value, row }: any) {
  if (value !== '') {
    return <SalvageTimelineModal barcode={row.barCode} />;
  }
  return '';
}

export const transferColumns = [
  {
    column: {
      Header: '',
      accessor: 'updateId',
      type: 'string',
      width: 50,
      resizable: true,
      Cell: editEOneItem,
      filterable: false,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Asset #',
      accessor: 'assetNumber',
      type: 'string',
      width: 70,
      resizable: true,
    },
    type: 'string',
  },

  {
    column: {
      Header: 'Barcode',
      accessor: 'barCode',
      type: 'string',
      resizable: true,
      width: 90,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Description 1',
      accessor: 'description1',
      resizable: true,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Description 2',
      accessor: 'description2',
      resizable: true,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Description 3',
      resizable: true,
      accessor: 'description3',
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Current Department',
      accessor: 'department',
      type: 'string',
      resizable: true,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Physical Owner',
      accessor: 'physicalOwner',
      type: 'string',
      width: 110,
      resizable: true,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Business Unit',
      accessor: 'businessUnit',
      type: 'string',
      width: 100,
      resizable: true,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Receiving Dept',
      accessor: 'toDeptName',
      type: 'string',
      resizable: true,
      // Cell: toDeptName,
      // filterMethod: (filter, row) => filterColumn(filter, row),
      // Filter: ({filter, onChange}) => filterComponent({filter, onChange})
    },
    type: 'string',
  },
  {
    column: {
      Header: 'DC',
      accessor: 'dcName',
      type: 'string',
      resizable: true
    },
    type: 'string'    
  },
  {
    column: {
      Header: 'Transfer Status',
      accessor: 'updateStatus',
      resizable: true,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Email?',
      type: 'string',
      width: 50,
      resizable: true,
      Cell: sendPCEMail,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Timeline',
      type: 'string',
      resizable: true,
      width: 60,
      Cell: transferTimeline,
    },
    type: 'string',
  },
];

function fixDate({ value, row }: any) {
  if (value !== '') {
    return <div style={{ textAlign: 'center' }}>{new Date(row.createdOn).toDateString()}</div>;
  }
  return '';
}

export const transferAuditColumns = [
  {
    Header: 'Status',
    accessor: 'comment',
    resizable: true,
  },
  {
    Header: 'Date',
    accessor: 'createdOn',
    resizable: true,
    width: 150,
    Cell: fixDate,
  },
  {
    Header: 'Who?',
    accessor: 'createdBy',
    resizable: true,
    width: 100,
    Cell: ({ value, row }) => {
      if (value !== '') {
        return <div style={{ textAlign: 'center' }}>{row.createdBy}</div>;
      }
      return '';
    },
  },
];
